<script>
import AppInputDouble from '@/components(new)/UI/Forms/InputDouble/InputDouble.vue'
import InputSelect from '@/components(new)/UI/Forms/InputSelect/InputSelect.vue'
import Label from '@/components(new)/UI/Forms/Label/Label.vue'
import TitleWithRow from '@/components(new)/UI/Typography/TitleWithRow/TitleWithRow.vue'
import EspecieEspacamento from '@/components(new)/UI/Forms/FormulariosProntos/EspecieEspacamento/EspecieEspacamento.vue'
import onlyInputNumbers from '@/components/mixins/OnlyInputNumber'
import { tiposEspeciesFlorestais } from '@/libs/utils/enums/enum.js'
import Bioinsumos from '@/components(new)/UI/Forms/FormulariosProntos/Bioinsumos/Bioinsumos.vue'
import Irrigacao from '@/components(new)/UI/Forms/FormulariosProntos/Irrigacao/Irrigacao.vue'
import Financiamentos from '@/components(new)/UI/Forms/FormulariosProntos/Financiamentos/Financiamentos.vue'
import * as slct from '@/libs/constants/praticas/opcoesSelects'

export default {
  mixins: [onlyInputNumbers],
  components: {
    TitleWithRow,
    Label,
    InputSelect,
    AppInputDouble,
    EspecieEspacamento,
    Bioinsumos,
    Irrigacao,
    Financiamentos
  },
  props: {
    pratica: {
      type: Object,
      required: true
    },
    observer: {
      required: true
    }
  },
  data () {
    return {
      nomeAba: 'Práticas',
      tiposEspeciesFlorestais,
      slct
    }
  },
  methods: {
    containsOption (parent, option, model) {
      let contains

      if (!Array.isArray(parent)) {
        contains = parent === option
      } else {
        contains = parent.includes(option)
      }

      if (!contains) {
        const props = model.split('.')
        const lastProp = props.pop()
        const target = props.reduce((acc, curr) => acc?.[curr], this.pratica)
        if (target && lastProp) {
          target[lastProp] = null
        }
      }
      return contains
    }
  }
}
</script>
<template>
  <div>
    <el-row :gutter="20">
      <validation-provider
        rules="area"
        v-slot="{ errors }"
        mode="lazy"
        :name="`${nomeAba}/Área`"
      >
        <el-col :span="8">
          <Label label="Área" obrigatorio />
          <AppInputDouble
            name='Área'
            :precision="2"
            :onkeypress="onlyInputNumbers"
            :showAppend ="true"
            v-model="pratica.area"
            :class="{'input erro' : errors.length}"
          />
          <span v-if="errors[0]" class="help erro"> {{ errors[0] }}</span>
        </el-col>
      </validation-provider>
      <validation-provider
        rules="required"
        v-slot="{ errors }"
        mode="lazy"
        :name="`${nomeAba}/Data início da implementação`"
      >
        <el-col :span="8">
          <Label
            label="Data de início da implementação"
            obrigatorio
          />
          <el-date-picker
            v-model="pratica.dataInicio"
            type="month"
            placeholder="Selecione mês e ano"
            format="MM/yyyy"
            value-format="yyyy-MM-dd"
            style="width: 100%"
            :class="{'input erro' : errors.length}"
          />
          <span v-if="errors[0]" class="help erro"> {{ errors[0] }}</span>
        </el-col>
      </validation-provider>
    </el-row>

    <TitleWithRow title="Componentes do sistema" />
    <div class="mb-2">
      <EspecieEspacamento
        :optionsSelect="slct.opcoesEspeciesFlorestaisSaf"
        tituloCard="Espécie florestal"
        label1="Espécies florestais"
        nomeArraySalvar="especies"
        :pratica="pratica"
        :nomeAba="nomeAba"
        :tipoEspecie="tiposEspeciesFlorestais.ESPECIE_FLORESTAL"
      />
    </div>

    <div class="mb-2">
      <EspecieEspacamento
        :optionsSelect="slct.opcoesEspeciesFrutiferas"
        tituloCard="Espécie frutífera"
        label1="Espécies frutíferas"
        nomeArraySalvar="especies"
        :pratica="pratica"
        :nomeAba="nomeAba"
        :tipoEspecie="tiposEspeciesFlorestais.ESPECIE_FRUTIFERA"
      />
    </div>

    <div class="mb-2">
      <EspecieEspacamento
        :optionsSelect="slct.opcoesEspeciesCicloCurto"
        tituloCard="Espécie ciclo curto e médio"
        label1="Espécies ciclo curto e médio"
        nomeArraySalvar="especies"
        :pratica="pratica"
        :nomeAba="nomeAba"
        :tipoEspecie="tiposEspeciesFlorestais.ESPECIE_ALIMENTAR_CICLO_CURTO_E_MEDIO"
      />
    </div>

    <EspecieEspacamento
      :optionsSelect="slct.opcoesEspeciesAdubadeiras"
      tituloCard="Espécie adubadeira ou de serviço"
      label1="Espécies adubadeiras ou de serviço"
      nomeArraySalvar="especies"
      :pratica="pratica"
      :nomeAba="nomeAba"
      :tipoEspecie="tiposEspeciesFlorestais.ESPECIE_ADUBEIRAS_OU_DE_SERVICO"
    />

    <Bioinsumos
      :pratica="pratica"
      :nomeAba="nomeAba"
    />

    <Irrigacao
      :pratica="pratica"
      :nomeAba="nomeAba"
    />

    <Financiamentos
      :pratica="pratica"
      :nomeAba="nomeAba"
    />

    <TitleWithRow title="" />
    <el-row :gutter="20">
      <validation-provider
        v-slot="{ errors }"
        mode="lazy"
        :name="`${nomeAba}/Descrição`"
      >
      <el-col :span="24">
        <Label
          label="Descrição"
        />
        <el-input
          name="Descrição"
          v-model="pratica.descricao"
          :class="{'input erro' : errors.length}"
          type="textarea"
          maxlength="500"
          show-word-limit
        />
        <span v-if="errors[0]" class="help erro"> {{ errors[0] }}</span>
      </el-col>
      </validation-provider>
    </el-row>
  </div>
</template>



// WEBPACK FOOTER //
// src/App/(authenticated)/modulos/cadastro/formulario-cadastro/praticas/form-praticas/SAF/SAF.vue